import React from "react";
import { CollectionMasterDataType, OwnerNftData } from "@/types";
import { useEffect, useState } from "react";
import { ItemFileData } from "@/types/collection";
import { backend } from "@/services/backend";
import { NftIndexCounter } from "./index-counter";

interface CollectionSkinCardProps {
  title: string;
  className?: string;
  item: ItemFileData | null;
  index?: number;
  onClick?: () => void;
}

const CollectionSkinCard = ({
  title,
  className,
  item,
  index,
  onClick,
}: CollectionSkinCardProps) => {
  return (
    <div
      className={`${className} relative flex flex-col items-center justify-center cursor-pointer`}
      onClick={onClick}
    >
      {index !== null && index !== undefined && (
        <NftIndexCounter index={index} />
      )}
      <img src={item?.image} className="object-contain" />
      <div className="flex flex-col w-full">
        <div className="flex items-center justify-center">
          {item?.name && item?.name.length > 7 ? (
            <>
              <span className="text-[12px]">{item?.name.slice(0, -3)}..</span>
              <span className="text-[12px]">{item?.name.slice(-3)}</span>
            </>
          ) : (
            <p className="text-[12px]">{item?.name}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CollectionSkinCard;
